import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Actions from '../../actions/actions';
import QAHiddenDriver from './qahiddendriver';
import LocationHelper from '../../helpers/location_helper';

const Button = ({ style, children, className, onClick, id }) => (
  <button id={id} onClick={onClick} style={{ height: '26px', ...style }}>
    {children}
  </button>
);

export const QAHidden = (props) => {
  const [qaHiddenState, setQaHiddenState] = useState({
    verification: '',
    signViaEmailToken: '',
    showDebug: '',
    mockModifiers: {
      includeDocGen: false,
      includeNotifyApp: false,
      includeStackApp: false,
      includeEnsemble: false,
      includeRealInverter: false,
      includeDupeInfo: false,
      includeRealAnalysis: false,
      productType: 'loan',
    },
  });

  const setState = (data) => {
    setQaHiddenState({
      ...qaHiddenState,
      ...data,
    });
  };

  const getSkuData = (sku) =>
    ({
      Pass: {
        firstname: 'QAHPass',
        lastname: 'TeStCaSe',
        ssn: 999999991,
      },
      StipsOptional: {
        firstname: 'QAHStipsOpt',
        ssn: 999999995,
      },
    }[sku]);

  useEffect(() => {
    if (LocationHelper.searchAsObj()?.qaHiddenSku) {
      QAHiddenDriver.tryAll({
        input: getSkuData(LocationHelper.searchAsObj()?.qaHiddenSku),
        mockModifiers: {
          includeDocGen: qaHiddenState.mockModifiers.includeDocGen,
        },
      });
    }
  }, [qaHiddenState.mockModifiers]);

  const renderMiniVTable = (tableElements) => {
    let title = tableElements[0].title;
    let titleElement = tableElements[0];
    if (title) {
      tableElements = tableElements.slice(1);
    }

    let tableInfo = { closeable: titleElement.closeable };

    if (titleElement.localStorageKey) {
      let storageInfo = localStorage.getItem(titleElement.localStorageKey);
      if (storageInfo) {
        tableInfo = JSON.parse(storageInfo);
      }
    }

    if (titleElement.localStorageKey && !tableInfo.open && tableInfo.closeable) {
      return (
        <div>
          <Button
            onClick={() => {
              localStorage.setItem(
                titleElement.localStorageKey,
                JSON.stringify(Object.assign({}, tableInfo, { open: true }))
              );
              setState({ [titleElement.localStorageKey]: { open: true } });
            }}
          >
            Open {title}
          </Button>
        </div>
      );
    }

    return (
      <div>
        <table border="1" style={{ border: '1px solid black' }}>
          <tbody>
            {title && (
              <tr>
                <th>{title}</th>
                {titleElement.localStorageKey && tableInfo.open && tableInfo.closeable && (
                  <td>
                    <Button
                      onClick={() => {
                        localStorage.setItem(
                          titleElement.localStorageKey,
                          JSON.stringify(Object.assign({}, tableInfo, { open: false }))
                        );
                        setState({ [titleElement.localStorageKey]: { open: false } });
                      }}
                    >
                      Close
                    </Button>
                  </td>
                )}
              </tr>
            )}
            {tableElements
              .filter((e) => e)
              .map((rowEl, rowIndex) => (
                <tr
                  key={'row-' + rowIndex}
                  style={{ backgroundColor: rowIndex % 2 === 0 ? 'rgba(200,200,200,0.5)' : '' }}
                >
                  <th key={'rowHeader-' + rowIndex}>{rowEl.name}</th>
                  <td key={'row-' + rowIndex} className={rowEl.class}>
                    {rowEl.value &&
                      (typeof rowEl.value === 'object' && rowEl.value?.$$typeof === undefined ? (
                        <Button
                          style={{ width: '100%' }}
                          onClick={() =>
                            QAHiddenDriver.tryAll({ input: rowEl.value, mockModifiers: qaHiddenState.mockModifiers })
                          }
                        >
                          Go!
                        </Button>
                      ) : (
                        <>{rowEl.value}</>
                      ))}
                    {rowEl.customRender}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    );
  };

  const mockModifierCheckbox = ({ id, label, field }) => (
    <>
      <input
        type="checkbox"
        id={id}
        name={id}
        style={{ width: 'fit-content', margin: '5px' }}
        value={qaHiddenState.mockModifiers[field]}
        onChange={(e) => setState({ mockModifiers: { ...qaHiddenState.mockModifiers, [field]: e.target.checked } })}
      />
      <label htmlFor={id}>{label}</label>
    </>
  );

  const renderMiniTable = (tableElements) => {
    let title = tableElements[0].title;
    if (title) {
      tableElements = tableElements.slice(1);
    }
    return (
      <div style={{ paddingTop: 5 }}>
        <table border="1" cellPadding="5" cellSpacing={'5'}>
          <tbody>
            {title && (
              <tr>
                <th>{title}</th>
              </tr>
            )}
            <tr>
              {tableElements.map((rowEl, rowIndex) => (
                <th key={'rowHeader-' + rowIndex}>{rowEl.name}</th>
              ))}
            </tr>
            <tr>
              {tableElements.map((colEl, rowIndex) => (
                <td key={'row-' + rowIndex} className={colEl.class}>
                  {colEl.value &&
                    (typeof colEl.value === 'object' ? (
                      <Button
                        onClick={() =>
                          QAHiddenDriver.tryAll({ input: colEl.value, mockModifiers: qaHiddenState.mockModifiers })
                        }
                      >
                        Go!
                      </Button>
                    ) : (
                      <>{colEl.value}</>
                    ))}
                  {colEl.customRender}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const updateVerification = () => {
    if (props.customer && props.customer.id) {
      Actions.fetchVerification({
        customerId: props.customer.id,
        callback: (verifications) => {
          let token;
          let emailToken;
          verifications.forEach((verification) => {
            if (verification.type === 'Homeowner_Credit_Documents') {
              token = verification.token;
            }
            if (verification.type === 'Sign_By_Email') {
              emailToken = verification.token;
            }
          });
          setState({
            verification: token,
            signViaEmailToken: emailToken,
          });
        },
      });
    }
  };

  const debugCookie = () => {
    try {
      return (
        document.cookie
          .split(';')
          .reduce((acc, c) => Object.assign(acc, { [c.split('=')[0].trim()]: c.split('=')[1].trim() }), {}).debug ===
        'true'
      );
    } catch (e) {}
    return null;
  };

  const subrender = () => {
    const {
      user,
      customer,
      proposal,
      eligibility,
      qaPricingGroup,
      qaBranch,
      qaSigner,
      qaSubscription,
      qaCreatedCompany,
      qaUser,
      welcomeCallResponses,
      mfaTokenResponse,
      otpTokenResponse,
    } = props;
    const { verification } = qaHiddenState;
    if (verification) {
      console.log(verification);
    }
    const guestSession = (() => {
      try {
        return JSON.parse(sessionStorage.getItem('guestOauthToken')).item;
      } catch (e) {}
      return null;
    })();

    const hector = (overrides) =>
      Object.assign(
        {},
        {
          zip: 33309,
          firstname: 'Hector',
          lastname: 'Maldonado',
          ssn: 666427154,
          address1: '4138 NW 12th Terrace',
          income: 96150,
        },
        overrides
      );

    const michelle = (overrides) =>
      Object.assign(
        {},
        {
          zip: 45238,
          firstname: 'Michelle',
          lastname: 'Frickerdunway',
          ssn: 666040681,
          address1: '195 Silverspring Dr',
          income: 95000, //95k est && monthly debt 6890 w/low FICO fails DTI; needs large stated in order to pass w/req stips
        },
        overrides
      );

    const henry = (overrides) =>
      Object.assign(
        {},
        {
          zip: 61754,
          firstname: 'Henry',
          lastname: 'Blake',
          ssn: 666114077,
          address1: '4077 Adlei',
          income: 100000,
          dob: '01/01/1991',
        },
        overrides
      );

    const renderEmailSignLinks = () => {
      let { financingRequest, customer } = props;
      let { signViaEmailToken } = qaHiddenState;

      if (!financingRequest || !signViaEmailToken || !customer) {
        return <></>;
      }

      let currentStepId = financingRequest.currentUnapprovedStepId;
      let currentEnvelopeId = (
        (financingRequest.steps || []).find((step) => step.id === currentStepId).docs || []
      ).find(({ currentRevision }) => currentRevision.currentEnvelopeId).currentRevision.currentEnvelopeId;

      let encodedApplicantFullname = encodeURIComponent(`${customer?.cfirstname} ${customer?.clastname}`);
      let encodedCoAppFullname = encodeURIComponent(`${customer?.csecondaryfirstname} ${customer?.csecondarylastname}`);

      return renderMiniTable([
        {
          name: 'app-sign-link',
          class: 'qa-app-emailsign-verification-link',
          customRender: (
            <a
              href={`/customers/0/signInPerson?token=${signViaEmailToken}&envelopeId=${currentEnvelopeId}&signerName=${encodedApplicantFullname}&signerRole=applicant`}
              target={'_blank'}
              rel="noopener noreferrer"
            >
              Go
            </a>
          ),
        },
        {
          name: 'coapp-sign-link',
          class: 'qa-coapp-emailsign-verification-link',
          customRender: (
            <a
              href={`/customers/0/signInPerson?token=${signViaEmailToken}&envelopeId=${currentEnvelopeId}&signerName=${encodedCoAppFullname}&signerRole=co_applicant`}
              target={'_blank'}
              rel="noopener noreferrer"
            >
              Go
            </a>
          ),
        },
        {
          name: 'signer-sign-link',
          class: 'qa-signer-emailsign-verification-link',
          customRender: (
            <a
              href={`/customers/0/signInPerson?token=${signViaEmailToken}&envelopeId=${currentEnvelopeId}&signerRole=adhoc_subscriber`}
              target={'_blank'}
              rel="noopener noreferrer"
            >
              Go
            </a>
          ),
        },
      ]);
    };

    return (
      <div
        className={`qa-hidden-component  ${debugCookie() ? 'qa-shown' : 'qa-hidden'}`}
        style={{
          padding: '10px 10px 10px 15px',
          position: 'absolute',
          left: '15px',
          top: '50px',
          zIndex: '-1',
          color: 'black',
          // background: 'rgba(0, 98, 190, 0.5)',
          border: 'solid black 1px',
          backgroundImage:
            'linear-gradient( 136deg, rgba(95, 163, 262, 0.5) 0%, rgba(55, 123, 222, 0.5) 50%, rgba(35, 93, 192, 0.5) 100%)',
          // boxShadow: '0px 0px 10px rgba(0, 0, 0, 01)',
          borderRadius: '15px',
        }}
      >
        <h2 style={{ margin: 0, padding: 0 }}>Developer Tools</h2>

        {/*{renderMiniTable([*/}
        {/*  {*/}
        {/*    name: 'Debug',*/}
        {/*    value: (*/}
        {/*      <Button id="qa-magic-debug" onClick={() => setState({ showDebug: !qaHiddenState.showDebug })}>*/}
        {/*        GO!*/}
        {/*      </Button>*/}
        {/*    ),*/}
        {/*  },*/}
        {/*  {*/}
        {/*    name: 'Keep Visible',*/}
        {/*    value: (*/}
        {/*      <button id="qa-magic-keepalive" onClick={() => (document.cookie = 'debug=true')}>*/}
        {/*        GO!*/}
        {/*      </button>*/}
        {/*    ),*/}
        {/*  },*/}
        {/*])}*/}

        {qaPricingGroup &&
          renderMiniTable([
            { name: 'PricingGroupId', value: qaPricingGroup.id },
            { name: 'PricingGroup COID', value: qaPricingGroup.coid },
          ])}

        {qaBranch &&
          renderMiniTable([
            { name: 'BranchId', value: qaBranch?.id },
            { name: 'Branch COID', value: qaBranch?.coid },
          ])}

        {qaSigner &&
          renderMiniTable([
            { name: 'signerId', value: qaSigner?.id },
            { name: 'signerEmail', value: qaSigner?.emailAddress },
          ])}

        {qaSubscription &&
          renderMiniTable([
            { name: 'subscriptionId', value: qaSubscription?.id },
            { name: 'subscriptionEmail', value: qaSubscription?.email },
            { name: 'subscriptionType', value: qaSubscription?.eventType },
            { name: 'subscriptionRole', value: qaSubscription?.role },
          ])}

        {qaCreatedCompany && renderMiniTable([{ name: 'createdCompanyId', value: qaCreatedCompany?.company?.coid }])}

        <Button
          className={'btn btn-primary btn-lg pull-left action-primary'}
          style={{ height: '22px', paddingTop: '0px' }}
          onClick={() => QAHiddenDriver.getPreferredContactInfo()}
        >
          Setup Preferred Contact
        </Button>

        {proposal &&
          renderMiniVTable(
            [
              { title: 'Page Info', closeable: false, open: true, localStorageKey: 'pageInfoWidget' },
              customer ? { name: 'CustId', class: 'qa-customerId', value: customer.id } : undefined,
              { name: 'PropId', class: 'qa-proposalId', value: proposal.id },
              {
                name: 'QPRId',
                class: 'qa-quotingProposalRevisionId',
                value: proposal?.lastApprovedHomeownerRevisionId,
              },
              { name: 'FMId', class: 'qa-financingMethodId', value: proposal?.financingMethods[0]?.id },

              eligibility?.creditCheck
                ? {
                    name: 'CaseId',
                    class: 'qa-caseId',
                    value: eligibility?.creditCheck?.financingProducts?.[0]?.externalId || 'None',
                  }
                : undefined,
              eligibility?.creditCheck
                ? { name: 'CCId', class: 'qa-creditCheckId', value: eligibility?.creditCheck?.id || 'None' }
                : undefined,

              { name: 'FRID', class: 'qa-financingRequestId', value: proposal?.financingRequestId },
              user ? { name: 'UserId', class: 'qa-userId', value: user?.id } : undefined,
              user ? { name: 'COID', class: 'qa-coid', value: user?.company?.coid } : undefined,
            ].filter((e) => e)
          )}

        {customer && renderMiniTable([{ name: 'Email', class: 'qa-cemail', value: customer.cemail }])}

        {user?.resumeAppTokenNoCaptcha &&
          renderMiniTable([
            {
              name: 'resumeWithNoCaptcha',
              class: 'resume-app-resumeAppTokenNoCaptcha',
              value: user.resumeAppTokenNoCaptcha,
            },
          ])}
        {user?.resumeAppTokenCaptcha &&
          renderMiniTable([
            { name: 'resumeWithCaptcha', class: 'resume-app-resumeAppTokenCaptcha', value: user.resumeAppTokenCaptcha },
          ])}

        {user &&
          guestSession &&
          renderMiniTable([{ name: 'Guest Sess', class: 'qa-guest-session', value: guestSession }])}

        {eligibility?.creditCheck &&
          renderMiniTable([
            {
              name: 'ConsentToken',
              class: 'qa-consent-token',
              value: eligibility?.creditCheck?.consentToken || 'None',
            },
            {
              name: 'link',
              class: 'qa-consent-token-link',
              value: (
                <a
                  href={`/homeowner/consent/${eligibility?.creditCheck?.consentToken}`}
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  Go
                </a>
              ),
            },
          ])}

        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <h4 style={{ marginBottom: '0' }}>mock modifiers</h4>
          <div className="flex-row">
            {mockModifierCheckbox({ id: 'doc-gen-check', label: 'docgen', field: 'includeDocGen' })}
            {mockModifierCheckbox({ id: 'notify-app-check', label: 'notifyApp', field: 'includeNotifyApp' })}
          </div>
          <div className="flex-row">
            {mockModifierCheckbox({ id: 'duplicate-info-check', label: 'dupeInfo', field: 'includeDupeInfo' })}
            {mockModifierCheckbox({ id: 'stack-check', label: 'stackApp', field: 'includeStackApp' })}
            {mockModifierCheckbox({ id: 'ensemble-check', label: 'ensemble', field: 'includeEnsemble' })}
          </div>
          <div className="flex-row">
            {mockModifierCheckbox({ id: 'real-analysis-check', label: 'realAnalysis', field: 'includeRealAnalysis' })}
            {mockModifierCheckbox({ id: 'real-inverter-check', label: 'realInverter', field: 'includeRealInverter' })}
          </div>
          <div className="flex-row">
            <label htmlFor="qa-loan-product">Product: </label>
            <select
              id="qa-loan-product"
              style={{ width: '100%', marginLeft: '15px' }}
              onChange={(e) =>
                setState({ mockModifiers: { ...qaHiddenState.mockModifiers, productType: e.target.value } })
              }
            >
              <option value="loan">Loan</option>
              <option value="hvac">HVAC</option>
              <option value="battery">Battery</option>
              <option value="cash">Cash</option>
            </select>
          </div>
        </div>

        {/*{renderMiniTable([*/}
        {/*  { title: <label>Quick Check</label> },*/}
        {/*  {*/}
        {/*    name: 'Pass',*/}
        {/*    class: 'qa-magic-qc-pass',*/}
        {/*    value: (*/}
        {/*      <button*/}
        {/*        onClick={this.quickCheck({*/}
        {/*          zip: 28217,*/}
        {/*          firstname: 'MARGARET',*/}
        {/*          lastname: 'SCARDINA',*/}
        {/*          address1: '735 CANDLER ln',*/}
        {/*        })}*/}
        {/*      >*/}
        {/*        GO!*/}
        {/*      </button>*/}
        {/*    ),*/}
        {/*  },*/}
        {/*  {*/}
        {/*    name: 'Fail',*/}
        {/*    class: 'qa-magic-qc-fail',*/}
        {/*    value: (*/}
        {/*      <button*/}
        {/*        onClick={this.quickCheck({*/}
        {/*          zip: 48060,*/}
        {/*          firstname: 'James',*/}
        {/*          lastname: 'Ewing',*/}
        {/*          address1: '180 Meadow Ln',*/}
        {/*        })}*/}
        {/*      >*/}
        {/*        GO!*/}
        {/*      </button>*/}
        {/*    ),*/}
        {/*  },*/}
        {/*  {*/}
        {/*    name: 'Freeze',*/}
        {/*    class: 'qa-magic-qc-freeze',*/}
        {/*    value: (*/}
        {/*      <button*/}
        {/*        onClick={this.quickCheck({*/}
        {/*          zip: 53703,*/}
        {/*          firstname: 'Cheese',*/}
        {/*          lastname: 'Head',*/}
        {/*          address1: '201 Washington Avenue',*/}
        {/*        })}*/}
        {/*      >*/}
        {/*        GO!*/}
        {/*      </button>*/}
        {/*    ),*/}
        {/*  },*/}
        {/*])}*/}

        {renderMiniVTable([
          { title: 'TU Mocks', closeable: true, open: false, localStorageKey: 'tuWidget' },
          {
            name: 'Pass - Michelle High Stated',
            class: 'qa-magic-michelle-use-stated',
            value: michelle({ income: 270000 }),
          },
          {
            name: 'Fail - Michelle Low Stated',
            class: 'qa-magic-michelle-use-estimated',
            value: michelle({ income: 9000 }),
          },
          {
            name: 'Pend T - Michelle',
            class: 'qa-magic-michelle-stip-pend-t',
            value: michelle({ dob: '03/01/1992', income: 300000 }),
          },
          {
            name: 'Pass - Hector High Stated',
            class: 'qa-magic-hector-use-est-high',
            value: hector({ income: 500000 }),
          },
          {
            name: 'Pass - Hector Low Stated',
            class: 'qa-magic-hector-use-est-low',
            value: hector({ income: 5000 }),
          },
          //this is the only title case that sends a "pended" email, all other title cases send "conditionally approved"
          {
            name: 'Pend T NoHit - Hector',
            class: 'qa-magic-hector-title-pend-nohit',
            value: hector({ dob: '01/01/1990' }),
          },
          {
            name: 'Pend T PartMatch - Hector',
            class: 'qa-magic-hector-title-pend-name',
            value: hector({ dob: '02/01/1991' }),
          },
          {
            name: 'Pend Fraud Alert - Henry',
            class: 'qa-magic-henry-pend-fraud-alert',
            value: henry(),
          },
        ])}

        {renderMiniVTable([
          { title: 'Bonita Credit Mocks', closeable: true, open: false, localStorageKey: 'magicWidgetCredit' },
          {
            name: '991(Pass)',
            class: 'qa-magic-bpass',
            value: { firstname: 'QAHPass', ssn: 999999991 },
          },
          {
            name: '992(VOI/VOM)',
            class: 'qa-magic-bvom',
            value: { firstname: 'QAHVOM', ssn: 999999992 },
          },
          {
            name: '993(Fail FICO)',
            class: 'qa-magic-bfail',
            value: { firstname: 'QAHFail', ssn: 999999993 },
          },
          {
            name: '994(StipsReq)',
            class: 'qa-magic-bstipsreq',
            value: { zip: 98843, firstname: 'QAHStipsReq', ssn: 999999994 },
          },
          {
            name: '984(StipsAndIdReq)',
            class: 'qa-magic-bstipsidreq',
            value: { zip: 98843, firstname: 'QAHStipsIdReq', ssn: 999999984 },
          },
          {
            name: '995(StipsOpt)',
            class: 'qa-magic-bstipsopt',
            value: { firstname: 'QAHStipsOpt', ssn: 999999995 },
          },
          {
            name: '996(OFAC)',
            class: 'qa-magic-bpend',
            value: { firstname: 'QAHOFAC', ssn: 999999996 },
          },
          {
            name: '996(OFAC+Pend Title)',
            class: 'qa-magic-bbothpend',
            value: { firstname: 'QAH_996_TITLE_PEND', ssn: 999999996, dob: '03/01/1991' },
          },
          {
            name: '997(highFICOFail)',
            class: 'qa-magic-bhighficofail',
            value: { firstname: 'QAH_997', ssn: 999999997 },
          },
          {
            name: '998(Frozen)',
            class: 'qa-magic-bfrozen',
            value: { firstname: 'QAHFreeze', ssn: 999999998 },
          },
          {
            name: '498(FrozenThenStip)',
            class: 'qa-magic-bfrozenstip',
            value: { firstname: 'QAHFreezeThenStip', ssn: 999999498 },
          },
        ])}
        {renderMiniVTable([
          { title: 'Title', closeable: true, open: false, localStorageKey: 'magicWidgetTitle' },
          {
            name: '995(LUPend)',
            class: 'qa-magic-blandusetitlepend',
            value: { firstname: 'QAH_995_TITLE_PEND', ssn: 999999995, dob: '01/02/1991' },
          },
          {
            name: '995(TrustPend)',
            class: 'qa-magic-btrusttitlepend',
            value: { firstname: 'QAH_995_TRUST_PEND', ssn: 999999995, dob: '02/02/1992' },
          },
          {
            name: '995(TrustPass)',
            class: 'qa-magic-btrusttitlepass',
            value: { firstname: 'QAH_995_TRUST_PASS', ssn: 999999995, dob: '01/01/1992' },
          },
          {
            name: '995(NoTitleHit)',
            class: 'qa-magic-bnotitlehitpend',
            value: { firstname: 'QAH_995_NOTITLEHIT_PEND', ssn: 999999995, dob: '01/01/1980' },
          },
          {
            name: '995(NoApn)',
            class: 'qa-magic-bnoapn',
            value: { firstname: 'QAH_995_NOAPN', ssn: 999999995, dob: '01/22/1991' },
          },
        ])}
        {renderMiniVTable([
          { title: 'Coapp', closeable: true, open: false, localStorageKey: 'magicWidgetCoApp' },
          {
            name: 'Pass(AKA)',
            class: 'qa-magic-bothAka',
            value: {
              firstname: 'QAH_983_APP',
              coappFirst: 'QAH_983_COAPP',
              dob: '01/01/1991',
              ssn: 999999996,
              coappDob: '01/01/1981',
              coappSsn: 999999999,
            },
          },
          {
            name: 'Pass(Both Res+Title)',
            class: 'qa-magic-bothResTitle',
            value: {
              firstname: 'QAH_983_APP',
              coappFirst: 'QAH_983_COAPP',
              dob: '01/01/1991',
              ssn: 999999995,
              coappDob: '01/01/1981',
              coappSsn: 999999999,
            },
          },
          {
            name: 'Pass(Both NonRes+Title)',
            class: 'qa-magic-bothNonResTitle',
            value: {
              firstname: 'QAH_991_APP',
              coappFirst: 'QAH_992_COAPP',
              dob: '01/01/1991',
              ssn: 999999991,
              coappDob: '01/01/1981',
              coappSsn: 999999992,
            },
          },
          {
            name: 'Pass(AppRes+CoappTitle)',
            class: 'qa-magic-appResCoappTitle',
            value: {
              firstname: 'QAH_995_APP_RES',
              coappFirst: 'QAH_992_COAPP_TITLE',
              dob: '03/01/1991',
              ssn: 999999995,
              coappDob: '01/01/1981',
              coappSsn: 999999992,
            },
          },
          {
            name: 'PendCredit(AppNone)',
            class: 'qa-magic-appNoneCoappResTitle',
            value: {
              firstname: 'QAH_991_APP_NONE',
              coappFirst: 'QAH_995_COAPP',
              dob: '02/01/1991',
              ssn: 999999991,
              coappDob: '01/01/1981',
              coappSsn: 999999995,
            },
          },
          {
            name: 'PendBoth(appRes+NoHit)',
            class: 'qa-magic-appResTitleNoHit',
            value: {
              firstname: 'QAH_995_APP_RES',
              coappFirst: 'QAH_992_COAPP_NOHIT',
              dob: '01/01/1990',
              ssn: 999999995,
              coappDob: '01/01/1981',
              coappSsn: 999999992,
            },
          },
          {
            name: 'PassBoth',
            class: 'qa-magic-passBoth',
            value: { firstname: 'QAHAppPass', coappFirst: 'QAHCoappPass', ssn: 999999991, coappSsn: 999999995 },
          },
          {
            name: 'PassAppStipCoapp',
            class: 'qa-magic-passAppStipCoapp',
            value: { firstname: 'QAHAppPass', coappFirst: 'QAHCoappStip', ssn: 999999995, coappSsn: 999999994 },
          },
          {
            name: 'PassAppBlockCoapp',
            class: 'qa-magic-passAppBlockCoapp',
            value: { firstname: 'QAHAppPass', coappFirst: 'QAHCoappBlock', ssn: 999999995, coappSsn: 999999998 },
          },
          {
            name: 'PassAppFailCoapp',
            class: 'qa-magic-passAppFailCoapp',
            value: { firstname: 'QAHAppPass', coappFirst: 'QAHCoappFail', ssn: 999999995, coappSsn: 999999993 },
          },
          {
            name: 'StipAppPassCoapp',
            class: 'qa-magic-stipAppPassCoapp',
            value: { firstname: 'QAHAppStip', coappFirst: 'QAHCoappPass', ssn: 999999994, coappSsn: 999999995 },
          },
          {
            name: 'StipAppBlockCoapp',
            class: 'qa-magic-stipAppBlockCoapp',
            value: { firstname: 'QAHAppStip', coappFirst: 'QAHCoappBlock', ssn: 999999994, coappSsn: 999999998 },
          },
          {
            name: 'StipAppFailCoapp',
            class: 'qa-magic-stipAppFailCoapp',
            value: { firstname: 'QAHAppStip', coappFirst: 'QAHCoappFail', ssn: 999999994, coappSsn: 999999993 },
          },
          {
            name: 'BlockAppPassCoapp',
            class: 'qa-magic-blockAppPassCoapp',
            value: { firstname: 'QAHAppBlock', coappFirst: 'QAHCoappPass', ssn: 999999998, coappSsn: 999999995 },
          },
          {
            name: 'BlockAppStipCoapp',
            class: 'qa-magic-blockAppStipCoapp',
            value: { firstname: 'QAHAppBlock', coappFirst: 'QAHCoappStip', ssn: 999999998, coappSsn: 999999994 },
          },
          {
            name: 'BlockAppFailCoapp',
            class: 'qa-magic-blockAppFailCoapp',
            value: { firstname: 'QAHAppBlock', coappFirst: 'QAHCoappFail', ssn: 999999998, coappSsn: 999999993 },
          },
          {
            name: 'FailAppPassCoapp',
            class: 'qa-magic-failAppPassCoapp',
            value: { firstname: 'QAHAppFail', coappFirst: 'QAHCoappPass', ssn: 999999993, coappSsn: 999999995 },
          },
          {
            name: 'FailAppStipCoapp',
            class: 'qa-magic-failAppStipCoapp',
            value: { firstname: 'QAHAppFail', coappFirst: 'QAHCoappStip', ssn: 999999993, coappSsn: 999999994 },
          },
          {
            name: 'FailAppBlockCoapp',
            class: 'qa-magic-failAppBlockCoapp',
            value: { firstname: 'QAHAppFail', coappFirst: 'QAHCoappBlock', ssn: 999999993, coappSsn: 999999998 },
          },
          {
            name: 'IdAppPassCoapp',
            class: 'qa-magic-idAppStipCoapp',
            value: { firstname: 'QAHAppId', coappFirst: 'QAHCoappPass', ssn: 999999981, coappSsn: 999999991 },
          },
          {
            name: 'IdBoth',
            class: 'qa-magic-idAppIdCoapp',
            value: { firstname: 'QAHAppId', coappFirst: 'QAHCoappId', ssn: 999999981, coappSsn: 999999989 },
          },
          {
            name: 'IdBothStipApp',
            class: 'qa-magic-idStipAppIdCoapp',
            value: { firstname: 'QAHAppIdStip', coappFirst: 'QAHCoappId', ssn: 999999984, coappSsn: 999999989 },
          },
          {
            name: 'NQAppDeclinedCoApp',
            class: 'qa-magic-nqAppDeclinedCoapp',
            value: { firstname: 'QAHAppNQ', coappFirst: 'QAHCoappDeclined', ssn: 999999997, coappSsn: 999999993 },
          },
          {
            name: 'BlockedAppNQCoApp',
            class: 'qa-magic-blockedAppNQCoapp',
            value: { firstname: 'QAHAppBlocked', coappFirst: 'QAHCoappNQ', ssn: 999999998, coappSsn: 999999997 },
          },
          {
            name: 'StipAppNQCoApp',
            class: 'qa-magic-stipAppNQCoapp',
            value: { firstname: 'QAHAppStip', coappFirst: 'QAHCoappNQ', ssn: 999999994, coappSsn: 999999997 },
          },
          {
            name: 'SSNMismatchBoth(1digitOff)',
            class: 'qa-magic-ssnMismatchBoth',
            value: {
              firstname: 'QAHAppSSNMismatch1',
              coappFirst: 'QAHCoappSSNMismatch1',
              ssn: 999998991,
              coappSsn: 999998981,
            },
          },
          {
            name: 'SSNMismatchBoth(2digitOff)',
            class: 'qa-magic-ssnMismatchBoth',
            value: {
              firstname: 'QAHAppSSNMismatch2',
              coappFirst: 'QAHCoappSSNMismatch2',
              ssn: 999997991,
              coappSsn: 999997981,
            },
          },
        ])}

        {renderMiniVTable([
          { title: 'Niche', closeable: true, open: false, localStorageKey: 'nicheWidget' },
          {
            name: 'AutoPay Plaid Database',
            class: 'qa-magic-plaidjohnsmith',
            value: { firstname: 'John', lastname: 'Smith', ssn: 999999991 },
          },
          {
            name: 'Java Bonita Mock Pass',
            class: 'qa-magic-javamockpass',
            value: { firstname: 'JavaMockPass', ssn: 777777777 },
          },
          {
            name: '909(Penalty Box) User',
            class: 'qa-magic-penaltybox',
            value: { firstname: 'QAHPass', ssn: 999090909 },
          },
          {
            name: '991(Pass) 123 déér str',
            class: 'qa-magic-special-char',
            value: { firstname: 'Daniél', lastname: 'Irwín', ssn: 999999991, address1: '123 déér str' },
          },
        ])}

        {renderMiniTable([
          {
            name: 'Verification',
            customRender: (
              <Button id="qa-magic-verification" onClick={updateVerification}>
                GO!
              </Button>
            ),
          },
          { name: 'token', class: 'qa-verification', value: qaHiddenState.verification },
          { name: 'emailtoken', class: 'qa-emailsign-verification', value: qaHiddenState.signViaEmailToken },
          {
            name: 'link',
            class: 'qa-verification-link',
            customRender: (
              <a
                href={`/consent/provide-credit-documents/${qaHiddenState.verification}`}
                target={'_blank'}
                rel="noopener noreferrer"
              >
                Go
              </a>
            ),
          },
        ])}

        {renderEmailSignLinks()}

        {renderMiniTable([
          {
            //THIS IS USED BY QAA
            name: 'IndividualMarketingUrl',
            class: 'qa-generated-remote-share-url',
            value: `${props.IndividualMarketingUrl}`,
          },
        ])}

        {qaUser &&
          renderMiniTable([
            {
              name: 'UserId',
              value: qaUser?.userid,
            },
            {
              //THIS IS USED BY QAA
              name: 'Temp_Password',
              class: 'qa-temp-password',
              value: qaUser?.tempPassword,
            },
          ])}

        {renderMiniTable([
          {
            //THIS IS USED BY QAA
            name: 'UW Dash',
            class: 'qa-goto-uw',
            customRender: (
              <a
                href={`${window.location.protocol + '//' + window.location.host.replace(/switch/g, 'uw')}`}
                target={'_self'}
                rel="noopener noreferrer"
              >
                link opens in this tab
              </a>
            ),
          },
        ])}
        {props.financingRequest && (
          <div>
            EnvelopeId:{' '}
            <div className={'qa-envelope-id'}>
              {(props.financingRequest.steps[0].docs || []).reduce(
                (acc, { currentRevision }) => currentRevision?.currentEnvelopeId,
                0
              )}
            </div>
          </div>
        )}
        {props.financingRequest &&
          renderMiniVTable(
            [
              {
                title: 'Docusign Envelopes',
                closeable: true,
                open: false,
                localStorageKey: 'docusignWidget',
              },
            ].concat(
              (props.financingRequest.steps[0].docs || []).map(({ currentRevision }) => {
                const { currentEnvelopeId } = currentRevision || {};
                const { name } = currentRevision || {};

                return {
                  name: `${name || ''}`,
                  customRender: (
                    <a
                      href={`${window.location.host
                        .replace(/switch/g, 'tools')
                        .replace(':3000', ':4000')}/test/updatedocusign?envelopeId=${currentEnvelopeId}`}
                      target={'_blank'}
                      rel="noopener noreferrer"
                    >
                      {currentEnvelopeId}
                    </a>
                  ),
                };
              })
            )
          )}

        {!!welcomeCallResponses ? (
          renderMiniTable([
            {
              name: 'welcome call url',
              customRender: (
                <a
                  id={'qa-wc-url'}
                  href={`https://${window.location.host}/welcome-calls/${welcomeCallResponses?.token}`}
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  {`https://${window.location.host}/welcome-calls/${welcomeCallResponses?.token}`}
                </a>
              ),
            },
          ])
        ) : (
          <Button
            id="qa-fetch-wc-token"
            onClick={() => {
              Actions.fetchWelcomeCallByCustomerId(customer.id);
            }}
          >
            fetch welcome call url
          </Button>
        )}

        {renderMiniTable([
          {
            name: 'mfa token',
            value: mfaTokenResponse?.secret,
          },
        ])}

        {renderMiniTable([
          {
            name: 'otp token',
            value: otpTokenResponse?.token,
          },
        ])}

        <br />

        <div>
          <Button id="qa-start-polling" onClick={() => Actions.resumePolling()}>
            RESUME POLLING
          </Button>
          <Button id="qa-stop-polling" onClick={() => Actions.pausePolling()}>
            STOP POLLING
          </Button>
        </div>

        {/*{this.state.showDebug && <Debug name={'root'} />}*/}
      </div>
    );
  };

  const render = () => {
    try {
      return subrender();
    } catch (ex) {
      console.error('', ex);
      return <div className={'qahidden-error-occured'}></div>;
    }
  };

  return render();
};

QAHidden.propTypes = {
  user: PropTypes.object,
  customer: PropTypes.object,
  proposal: PropTypes.object,
  eligibility: PropTypes.object,
  financingRequest: PropTypes.object,
  IndividualMarketingUrl: PropTypes.string,
  qaPricingGroup: PropTypes.object,
  qaBranch: PropTypes.object,
  qaSigner: PropTypes.object,
  qaSubscription: PropTypes.object,
  qaCreatedCompany: PropTypes.object,
  qaUser: PropTypes.object,
  welcomeCallResponses: PropTypes.object,
  mfaTokenResponse: PropTypes.object,
  otpTokenResponse: PropTypes.object,
};

export default connect(
  ({
    user,
    customer,
    proposal,
    eligibility,
    financingRequest,
    IndividualMarketingUrl,
    qaPricingGroup,
    qaBranch,
    qaSigner,
    qaSubscription,
    qaCreatedCompany,
    qaUser,
    welcomeCallResponses,
    mfaTokenResponse,
    otpTokenResponse,
  }) => ({
    user,
    customer,
    proposal,
    eligibility,
    financingRequest,
    IndividualMarketingUrl,
    qaPricingGroup,
    qaBranch,
    qaSigner,
    qaSubscription,
    qaCreatedCompany,
    qaUser,
    welcomeCallResponses,
    mfaTokenResponse,
    otpTokenResponse,
  })
)(QAHidden);
